import { useMemo } from 'react';

import AppContent from '@Components/app-layout/Content';
import { useGlobalStore } from '@Stores/global';

import Routes from './Routes';
import Sidebar from './Sidebar';

export default function CMSLayout() {
  const { siteSettings: { useThemeConfig } } = useGlobalStore();
  const typesConfig = useThemeConfig('types')

  const types = useMemo(() => typesConfig ? Object.entries(typesConfig) : null
    , [typesConfig])

  const typeKeys = useMemo(() => typesConfig ? Object.keys(typesConfig) : null
    , [typesConfig])

  return <AppContent>
    <Sidebar types={types} />
    <Routes types={typeKeys} />
  </AppContent>
}
